<template>
  <b-field>
    <div class="autocomplete" v-if="!resetting">
      <b-field>
        <b-taginput v-model="tags" ellipsis icon="caret-right" ref="searchinput" autocomplete :allow-new="true" :placeholder="$t('search.placeholder')" @focus="scrollToBox" expanded size="is-medium" @input="searchTags(false)" @typing="getFilteredTags" :data="this.dataTags"> </b-taginput>
        <p class="control">
          <button class="button is-primary is-medium" @click="searchTags()">
            <span class="icon is-medium" v-if="buttonType == 'icon'">
              <i class="fas fa-search"></i>
              <span class="sr-only">{{ $t('general.search') }}</span>
            </span>
            <span v-if="buttonType == 'text'" class="is-hidden-mobile" @click="searchWithButton()">{{ $t('general.search') }}</span>
          </button>
        </p>
      </b-field>

      <transition name="fade">
        <div class="dropdown-menu" v-if="isActive" ref="dropdown">
          <div class="dropdown-content">
            <a class="dropdown-item" :class="{'is-hovered': result === hovered}" v-for="(result, index) in data" :key="index" @click="selectItem(result)"><span v-html="highlightWord(result)"> </span></a>
          </div>
        </div>
      </transition>
    </div>
  </b-field>
</template>

<script>
import {mapGetters} from 'vuex'
import Api from '@/api/search-api'
import {debounce} from 'vue-debounce'
// import de from '../../../locales/de'
// import i18n from '../../../i18n'
// import store from '../../../store'
export default {
  name: 'SearchAutocomplete',
  props: {
    presetText: {
      type: String,
    },
    buttonType: {
      type: String,
    },
  },
  data() {
    return {
      inputValue: null, //has to be null to display placeholder
      //tags: null,
      data: [],
      dataTags: [],
      wordIndex: 0,
      tokens: [],
      selected: null,
      hovered: null,
      isActive: false,
      len: 0,
      resetting: false,
      inputPlaceholder: this.$t('search.placeholder') /*store.getters.locale, || sessionStorage.getItem("loc"), */,
    }
  },
  mounted() {
    if (this.presetText || this.presetText == '') {
      this.setWord(this.presetText)
    }
  },
  computed: {
    ...mapGetters({filter: '$_search/filter'}),
    currentToken() {
      if (!this.inputValue) return null
      return this.inputValue.replace(/(\r\n|\n|\r)/gm, ' ').split(' ')[this.wordIndex]
    },
    inputSplitted() {
      if (!this.inputValue) return []
      return this.inputValue.replace(/(\r\n|\n|\r)/gm, ' ').split(' ')
    },
    stopWords() {
      return ['/', '&', 'und']
    },
    tags: {
      get() {
        return this.filter.tags
      },
      set(value) {
        const nonEmpty = value.filter(f => f && f.length > 0)
        this.$store.dispatch('$_search/updateTags', nonEmpty)
      },
    },
    currentTypedValue() {
      return this.$refs.searchinput.$refs.autocomplete.value
    },
  },
  watch: {
    inputValue() {
      if (!this.resetting) {
        debounce(() => {
          this.focus()
        }, 300)
        this.wordIndex = this.inputSplitted.length - 1
      }
    },
    presetText() {
      this.inputValue = this.presetText
    },
  },
  methods: {
    reset() {
      this.resetting = true
      this.inputValue = null
      this.data = []
      this.wordIndex = 0
      this.tokens = []
      this.selected = null
      this.hovered = null
      this.isActive = false
      this.len = 0
      this.resetting = false
    },
    setHovered(option) {
      if (option === undefined) return
      this.hovered = option
    },
    keyArrows(direction) {
      const sum = direction === 'down' ? 1 : -1
      if (this.isActive) {
        let index = this.data.indexOf(this.hovered) + sum
        index = index > this.data.length - 1 ? this.data.length : index
        index = index < 0 ? 0 : index
        this.setHovered(this.data[index])
        const list = this.$refs.dropdown.querySelector('.dropdown-content')
        const element = list.querySelectorAll('a.dropdown-item:not(.is-disabled)')[index]
        if (!element) return
        const visMin = list.scrollTop
        const visMax = list.scrollTop + list.clientHeight - element.clientHeight
        if (element.offsetTop < visMin) {
          list.scrollTop = element.offsetTop
        } else if (element.offsetTop >= visMax) {
          list.scrollTop = element.offsetTop - list.clientHeight + element.clientHeight
        }
      } else {
        this.isActive = true
      }
    },
    highlightWord(word) {
      const regex = new RegExp('(' + this.currentToken + ')', 'gi')
      return word.replace(regex, '<mark>$1</mark>')
    },
    rebuildTokens() {
      let currentWords = this.inputValue.replace(/(\r\n|\n|\r)/gm, '__br__ ').split(' ')
      this.tokens = currentWords.filter(f => !this.stopWords.includes(f))
    },
    setWord(word) {
      if (this.inputValue !== null) {
        let currentWords = this.inputValue.replace(/(\r\n|\n|\r)/gm, '__br__ ').split(' ')
        let tokenizedInput = word
          .replace(/(\r\n|\n|\r)/gm, ' ')
          .split(' ')
          .filter(f => !this.stopWords.includes(f))
        this.tokens = this.tokens.concat(tokenizedInput)
        this.tokens.push(word)

        currentWords[this.wordIndex] = currentWords[this.wordIndex].replace(this.currentToken, word + ' ')
        this.wordIndex += tokenizedInput.length
        this.inputValue = currentWords.join(' ').replace(/__br__\s/g, '\n')
        this.data = this.data.filter(f => !this.tokens.includes(f))
      }
    },
    selectItem(i) {
      this.setHovered(i)
      this.chooseItem()
    },
    chooseItem() {
      if (this.hovered) {
        this.setWord(this.hovered)
        this.hovered = null
        this.isActive = false
      }
    },
    async focus() {
      if (this.currentToken && this.currentToken.length > 0) {
        if (this.currentToken && this.currentToken.trim() !== '') {
          try {
            let results = await Api.suggest(this.currentToken)
            this.data = results.filter(f => !this.tokens.includes(f))
            if (this.data.length > 0) {
              this.isActive = true
            }
          } catch {
            this.data = []
            this.isActive = false
          }
        }
        if (this.data.length === 1 && this.currentToken.toLowerCase() === this.data[0].toLowerCase()) {
          this.data = []
          this.isActive = false
        }
      } else {
        this.data = []
        this.isActive = false
      }
      if (this.len > this.inputValue.length) {
        this.rebuildTokens()
      }
      this.len = this.inputValue.length
    },
    async getFilteredTags(text) {
      if (text && text.length > 1) {
        let results = await Api.suggest(text)
        this.dataTags = results
      } else {
        this.dataTags = []
      }
    },
    enterPressed() {
      if (this.isActive && this.hovered) {
        this.chooseItem()
      } else {
        this.search()
      }
    },
    search() {
      if (this.inputValue && this.inputValue.length > 0) {
        this.$emit('execute-search', this.inputValue.trim())
      } else {
        this.$emit('execute-search', this.inputValue)
      }
      this.$scrollTo('#searchlist', 500, {
        offset: -160,
      })
    },
    searchTags(scrolling = false) {
      if (this.tags != null) {
        if (this.currentTypedValue.length == 0) {
          this.$emit('execute-search', this.tags.join(' '))
        } else {
          //use tags from taginput AND current typed value
          //await this.$store.dispatch('$_search/addTag', ` ${this.currentTypedValue}`)
          this.$emit('execute-search', this.tags.join(' ') + ` ${this.currentTypedValue}`)
        }
      }

      if (scrolling) {
        this.$scrollTo('#searchlist', 500, {
          offset: -160,
        })
      }
    },
    async searchWithButton() {
      await this.$store.dispatch('$_search/addTag', ` ${this.currentTypedValue}`)
      this.$refs.searchinput.$refs.autocomplete.value = ''
    },
    scrollToBox() {
      this.$scrollTo('#searchbox', 500, {
        offset: -160,
      })
    },
  },
}
</script>
<style>
.is-hovered {
  color: #d8000c;
  background-color: #ffbaba;
}
</style>
